import React, { Component } from "react";

import Api from "../../../../../lib/componentApi";
import getAppErrors from "../../../../../lib/appErrors";
import getPromoCodeInfo from "../../../../../lib/getPromoCodeInfo";

import PromoCodesDropdown from "./PromoCodesDropdown";

import AppErrors from "../../../../../components/Common/AppErrors";

export default class PromoDesktop extends Component {
  state = {
    addNew: false,
    promoCode: this.props.promoCode || "",
    appliedPromo: false,
    title: "",
    message: ""
  };
  addNewPromo = () => {
    this.setState({
      addNew: true,
      promoCode: ""
    });
  };
  onSelectPromo = promoCode => {
    this.setState({ promoCode });
  };
  handleChangePromo = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleUnselectPromo = () => {
    const { handleRemovePromo } = this.props;
    handleRemovePromo();
    this.setState({ promoCode: "", appliedPromo: false, addNew: false });
  };
  handleUsePromo = () => {
    const { promoCode } = this.state;
    const { points, getNewBasket } = this.props;
    Api.post("/api/use/promo/code", { promoCode }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (typeof response.code === "number") {
        const errorMessage = getAppErrors(response.code);
        this.setState({
          message: (errorMessage && errorMessage.message) || response.message
        });
      } else {
        const { title, message } = getPromoCodeInfo(
          response.gainStage,
          response.gainType,
          response.gainAmount,
          response.afterGainAmount,
          response.beforeGainAmount,
          points
        );
        if (message) {
          this.setState({ title, message });
        }
        this.setState({ appliedPromo: true }, () => {
          getNewBasket();
        });
      }
    });
  };
  handleSelectPromo = () => {
    const { promoCode } = this.state;
    const { points, getNewBasket } = this.props;
    Api.post("/api/select/promo/code", { promoCode }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (typeof response.code === "number") {
        if (response.code === 2601) {
          this.setState({
            message: "Your promo code is not valid."
          });
        } else {
          const errorMessage = getAppErrors(response.code);
          this.setState({
            message: (errorMessage && errorMessage.message) || response.message
          });
        }
      } else {
        const { title, message } = getPromoCodeInfo(
          response.gainStage,
          response.gainType,
          response.gainAmount,
          response.afterGainAmount,
          response.beforeGainAmount,
          points
        );
        if (message) {
          this.setState({ title, message });
        }
        this.setState({ appliedPromo: true }, () => {
          getNewBasket();
        });
      }
    });
  };
  onCloseError = () => {
    this.setState({
      title: "",
      message: ""
    });
  };
  render() {
    const { addNew, promoCode, appliedPromo, title, message } = this.state;
    const { useAblePromoCodes, closePromoDesktop } = this.props;
    return (
      <div>
        <div className="d-flex justify-content-between">
          <h5>Add Promo Code</h5>
          <p className="cancel-text cursor-pointer" onClick={closePromoDesktop}>
            Cancel <i className="icon icon-close-mini" />
          </p>
        </div>

        {(appliedPromo && (
          <div className="applied d-flex align-items-center">
            <div className="check sm">
              <input type="radio" checked disabled />
              <span className="checkmark" />
            </div>
            <p>
              Promo code applied - <span>{promoCode}</span>
            </p>
            <a href="javascript:void(0)" onClick={this.handleUnselectPromo}>
              (remove)
            </a>
          </div>
        )) ||
          (useAblePromoCodes &&
            useAblePromoCodes.length &&
            ((addNew && (
              <>
                <div className="d-flex align-items-center manuel-input">
                  <input
                    type="text"
                    id="promoCode"
                    value={promoCode.toUpperCase()}
                    onChange={this.handleChangePromo}
                  />
                  <button
                    className={`btn btn-${(promoCode && "blue") || "gray"}`}
                    onClick={this.handleUsePromo}
                    disabled={!promoCode}
                  >
                    Apply
                  </button>
                </div>
              </>
            )) || (
              <>
                <PromoCodesDropdown
                  promoCodes={useAblePromoCodes}
                  addNewPromo={this.addNewPromo}
                  selectedPromoCode={promoCode}
                  onSelectItem={this.onSelectPromo}
                />
                <button
                  className="btn btn-blue"
                  onClick={this.handleSelectPromo}
                >
                  Apply
                </button>
              </>
            ))) || (
            <div className="d-flex align-items-center manuel-input">
              <input
                type="text"
                id="promoCode"
                value={promoCode.toUpperCase()}
                onChange={this.handleChangePromo}
              />
              <button
                className={`btn btn-${(promoCode && "blue") || "gray"}`}
                onClick={this.handleUsePromo}
                disabled={!promoCode}
              >
                Apply
              </button>
            </div>
          )}
        {message && (
          <AppErrors
            title={title}
            message={message}
            onClickClose={this.onCloseError}
          />
        )}
      </div>
    );
  }
}
